module.exports = __webpack_public_path__ + "img/2951@2x.3315d075.png";